<template>
  <div>
    <el-table :data="ybordersData" :height="wheight-500"  v-loading="loading">
<!--      <el-table-column prop="id" label="ID" width="95"></el-table-column>-->
      <el-table-column prop="sku_id" label="商品ID" width="160"></el-table-column>
      <el-table-column prop="sku_bn" label="商品货号" width="160"></el-table-column>
      <el-table-column prop="sku_name" label="商品名称" width="160"></el-table-column>
      <el-table-column prop="share_total" label="分享数" width="100"></el-table-column>
      <el-table-column prop="click_total" label="点击数" width="100"></el-table-column>
      <el-table-column prop="updated_date" label="更新时间" width="160"></el-table-column>
    </el-table>
    <div v-if="total_count > pageSize" class="content-padded tc">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :total='total_count' :page-size="pageSize">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getClickList } from '../../../api/sharer'
import {mapGetters} from "vuex";
export default {
  props: ['userId', 'isLoad'],
  data () {
    return {
      loading: false,
      params: {},
      total_count: 0,
      currentPage: 1,
      pageSize: 20,
      ybordersData: []
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    handleCurrentChange (val) {
      this.currentPage = val
      this.loading = false
      this.getParams()
      this.getItems(this.params)
    },
    getParams () {
      this.params.page = this.currentPage
      this.params.pageSize = this.pageSize
    },
    getItems (filter) {
      console.log(filter)
      this.loading = true
      getClickList(filter).then(response => {
        this.ybordersData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
      })
    },
  },
  mounted () {
    // this.params = {page: this.currentPage, pageSize: this.pageSize, user_id: this.userId}
    // this.getItems(this.params)
  },
  watch: {
    userId (newVal, oldVal) {
      if (this.isLoad) {
        this.params = {page: this.currentPage, pageSize: this.pageSize, user_id: newVal}
        this.getItems(this.params)
      }
    },
    isLoad (newVal, oldVal) {
      if (newVal) {
        this.params = {page: this.currentPage, pageSize: this.pageSize, user_id: this.userId}
        this.getItems(this.params)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 10px;
  .frm-tips {
    color: #8d8d8d;
  }
}
</style>



// WEBPACK FOOTER //
// clicklist.vue?3512af5d